import { Divider } from "@atoms"

import styles from "./ColumnOrderingDivider.module.scss"
import { ColumnOrderingDividerProps } from "./ColumnOrderingDivider.types"

/** Splits the pinned columns from the unpinned ones in the column list. */
export default function ColumnOrderingDivider(props: ColumnOrderingDividerProps) {
    const { label } = props

    // TODO: Pass `isDashed={true}` once the dashed Divider from ROO-3293 is merged; the design draws this rule dotted.
    return (
        <div className={styles.base}>
            <Divider contrast="high" className={styles.line} />
            <span className={styles.label}>{label}</span>
            <Divider contrast="high" className={styles.line} />
        </div>
    )
}
